import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import BusinessPartnerUserModel from '../../../models/BusinessPartnerUserModel';
import DataService from "../../../services/data.service";
import { BusinessPartnerProps } from '../../../types/IdProps';
import AddBusinessPartnerUserPopup from '../Popups/BusinessPartner_popup_AddBusinessPartnerUser';

const BusinessPartner_tab_Logins: React.FC<BusinessPartnerProps> = ({ businessPartnerId, businessPartnerTypeId }) => {
    const [data, setData] = useState<BusinessPartnerUserModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [businessPartnerId]);

    function getTableData() {
        DataService.get<BusinessPartnerUserModel[]>('api/v1/BusinessPartnerUsers/ByBusinessPartner/' + businessPartnerId)
            .then(response => {
                console.log('bp-users:', response)
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/BusinessPartnerUsers/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Contactperson', dataProp: 'contactperson', sort: 'asc' },
        { title: 'Rol', dataProp: 'functionalRole' },
        { title: 'Login account', dataProp: 'user', dataType: 'user' },
    ];

    const { isAuthorizedFor } = useAuth();
    if (isAuthorizedFor(ApplicationFunctions.UpdateBusinessPartner)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtBusinessPartnerUsers'
                colInfos={colInfos}
                tableData={data}
            />
            {showPopup && <AddBusinessPartnerUserPopup businessPartnerId={businessPartnerId} businessPartnerTypeId={businessPartnerTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}

        </>
    );
}
export default BusinessPartner_tab_Logins;